import { createUseStyles } from 'react-jss'

import { transitionShort } from '../../styles/const/common'

const useStyles = createUseStyles({
  spoiler: {
    marginTop: 24
  },
  arrowIcon: {
    width: 12,
    height: 8,
    display: 'inline-block',
    marginRight: props => (props.isSmall ? 14 : 18),
    transition: transitionShort,
    transform: props => (props.opened ? 'rotate(0deg)' : 'rotate(-90deg)'),
    color: props => props.titleColor
  },
  spoilerTitle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    cursor: 'pointer',
    fontSize: props => (props.isSmall ? 14 : 16),
    fontWeight: 700,
    paddingBottom: 16,
    marginLeft: props => (props.hasMarginLeft ? 16 : 'unset'),
    color: props => props.titleColor
  },
  spoilerBody: {
    '& > *:first-child': {
      marginTop: 0
    }
  }
})

export default useStyles
